import React, {useState} from 'react';
import {Button, Form} from 'react-bulma-components';
import {RecurringTransaction, Transaction, OneTimeTransaction} from '../services/transaction/transaction.service';
import {env} from '../env';
import {isEmptyString} from '../utils/string.utils';

interface Props {
  isLoading: boolean;
  onSubmitted: (transaction: Transaction) => void;
}

const TransactionForm: React.FC<Props> = ({onSubmitted, isLoading}) => {
  const [cardNumber, setCardNumber] = useState<string | null>(null);
  const [amount, setAmount] = useState<string | null>(null);
  const [isRecurring, setIsRecurring] = useState<boolean>(false);

  const submitClicked = (): void => {
    const baseTransaction: Partial<Transaction> = {
      acctNumber: cardNumber!,
      merchantName: 'DemoShop',
      purchaseDate: new Date().toISOString(),
      notificationURL: env.notificationUrl,
    };

    const transactionAmountInCents = Math.round(parseFloat(amount ?? '') * 100);

    let transaction: Transaction;
    if (isRecurring) {
      transaction = {
        ...baseTransaction,
        recurringAmount: transactionAmountInCents,
        recurringCurrency: 'USD',
        recurringExponent: 2,
        recurringFrequency: 31,
      } as RecurringTransaction;
    } else {
      transaction = {
        ...baseTransaction,
        purchaseAmount: transactionAmountInCents,
        purchaseCurrency: 'USD',
        purchaseExponent: 2,
      } as OneTimeTransaction;
    }

    onSubmitted(transaction);
  };

  const isValid = !isEmptyString(cardNumber) && !isEmptyString(amount);

  return (
    <>
      <Form.Field>
        <Form.Label>
          Card Number
        </Form.Label>

        <Form.Control>
          <Form.Input
            value={cardNumber}
            onChange={({target}) => setCardNumber(target.value)}
          />
        </Form.Control>
      </Form.Field>

      <Form.Field>
        <Form.Label>
          Amount
        </Form.Label>

        <Form.Control>
          <Form.Input
            value={amount}
            type="number"
            onChange={({target}) => setAmount(target.value)}
          />
        </Form.Control>
      </Form.Field>

      <Form.Field>
        <Form.Control>
          <Form.Checkbox
            checked={isRecurring}
            onChange={({target}) => setIsRecurring(target.checked)}
          >
            Recurring Monthly
          </Form.Checkbox>
        </Form.Control>
      </Form.Field>

      <Form.Field kind="group" align="right">
        <Form.Control>
          <Button
            fullwidth
            rounded
            color="primary"
            disabled={!isValid}
            loading={isLoading}
            onClick={submitClicked}
          >
            Place your order
          </Button>
        </Form.Control>
      </Form.Field>
    </>
  );
};

export default TransactionForm;
